var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.79,
    height: 32,
    viewBox: "0 0 40.79 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VeryLowWiFi",
    transform: "translate(-2548 -326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M1490.781,132.185a2,2,0,0,1-1.415-.586,24.049,24.049,0,0,0-33.958,0,2,2,0,0,1-2.83-2.828,28.055,28.055,0,0,1,39.618,0,2,2,0,0,1-1.415,3.414Z",
    transform: "translate(1096.008 205.417)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M1509.059,171.688a2,2,0,0,1-1.415-.586,16.033,16.033,0,0,0-22.639,0,2,2,0,0,1-2.83-2.828,20.042,20.042,0,0,1,28.3,0,2,2,0,0,1-1.415,3.414Z",
    transform: "translate(1072.07 171.577)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M1527.338,211.186a2,2,0,0,1-1.415-.586,8.016,8.016,0,0,0-11.319,0,2,2,0,0,1-2.83-2.828,12.025,12.025,0,0,1,16.979,0,2,2,0,0,1-1.415,3.414Z",
    transform: "translate(1048.132 137.74)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M1541.73,254.1a4,4,0,1,1,2.83-1.17A3.991,3.991,0,0,1,1541.73,254.1Z",
    transform: "translate(1026.665 103.903)",
    opacity: 0.3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.2f6469c2f1fb0d6ffaace8aaba4f3050.svg";
export { ForwardRef as ReactComponent };